'use strict';

angular.module('licensure.services')
    .factory('Utils', ['$http', '$q', function ($http, $q) {
        return {
            GetCookieName: function (isPortal) {
                var d = $q.defer();

                $http
                    .get(apiLocation + '/api/utils/getcookiename', {
                        params: {
                            isPortal: isPortal
                        }
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },
            DeleteSessionCookie: function (isPortal) {
                var d = $q.defer();

                $http
                    .delete(apiLocation + '/api/Core/Auth/Sessioncookie', {
                        params: {
                            isPortal: isPortal
                        }
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            }

        }
    }])
;